import ReactMarkdown from 'react-markdown'
import { Typography } from 'antd'

interface MarkdownPreviewProps {
  content: string
}

export function MarkdownPreview({ content }: MarkdownPreviewProps) {
  if (!content) {
    return (
      <Typography.Text type="secondary" italic>
        Preview will appear here...
      </Typography.Text>
    )
  }

  return (
    <div className="markdown-preview">
      <ReactMarkdown
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          )
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
